import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import CustomForm from '../../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../../../application/config/config';
import Fetch from "../../../../core/util/core/Fetch";
import { chooseProfileFilter } from "../../../helpers/chooseProfileFilter";
import sleep from 'sleep-promise';

function Form() {
    const [formContent, setFormContent] = useState(<>Carregando...</>);
    const [form,setForm] = useState();
    const { id } = useParams();

    const profileFilter = chooseProfileFilter()

    const hiddenValues = {}

    if (profileFilter.pdc_entity_id) {
        hiddenValues.pdc_entity_id = profileFilter.pdc_entity_id
    }

    const path = '/clients/';
    const paths = {
        endpointGetAllEntities: config.endpoints.backend + 'entities/getall',
        endpointSave: config.endpoints.backend + 'clients/save',
        endpointGetById: config.endpoints.backend + 'clients/getById',
        endpointCnpjVerify: config.endpoints.backend + 'clients/cnpjVerify',
        urlGoBack: path + 'list',
        pathView: path + 'view'
    }

    const labels = {
        labelTitleAdd: "Novo Cliente",
        labelTitleEdit: "Editar Cliente",
        labelTitleView: 'Visualizar Cliente'
    }

    const getForm = (values) => {
        let form = {
            validateOnChange: true,
            hiddenValues: {
                ...hiddenValues
            },
            fields: [
                !hiddenValues.pdc_entity_id ? {
                    name: 'pdc_entity_id',
                    type: 'select',
                    label: 'Entidade',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllEntities,
                        label: 'corporate_name',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter
                            }
                        }
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 12,
                } : {},
                {
                    name: 'client_type',
                    type: 'select',
                    options: [
                        { label: 'Juridica', value: 'J' },
                        { label: 'Física', value: 'F' }
                    ],
                    handleChange: async (element,field,values) => {
                        let form = getForm(values);
                        setForm(values);
                        setFormContent(<></>);
                        await sleep(1);
                        setFormContent(
                        <CustomFormContainer 
                            form = {form}
                            content = {<CustomForm form={form}/>}
                        />)
                    },
                    label: 'Tipo de Pessoa',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                values.client_type === 'F' && {
                    name: 'cpf',
                    type: 'CPF',
                    label: 'CPF',
                    validations: {
                        required: true,
                    },
                    columnSize: 12
                },
                values.client_type === 'F' && {
                    name: 'name',
                    type: 'text',
                    label: 'Nome',
                    validations: {
                        required: true,
                    },
                    columnSize: 12
                },
                values.client_type === 'J' && {
                    name: 'cnpj',
                    type: 'CNPJ',
                    label: 'CNPJ',
                    validations: {
                        required: true,
                        cnpj_unique: true
                    },
                    columnSize: 12
                },
                values.client_type === 'J' && {
                    name: 'corporate_name',
                    type: 'text',
                    label: 'Razão social',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                values.client_type === 'J' && {
                    name: 'fantasy_name',
                    type: 'text',
                    label: 'Nome Fantasia',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                values.client_type === 'J' && {
                    name: 'municipal_registration',
                    type: 'text',
                    label: 'Inscrição Municipal',
                    validations: {
                        required: false
                    },
                    columnSize: 12
                },
                values.client_type === 'J' && {
                    name: 'estadual_registration',
                    type: 'text',
                    label: 'Inscrição Estadual',
                    mask: '999.999.999.999',
                    validations: {
                        required: false
                    },
                    columnSize: 12
                },
                values.client_type === 'J' && {
                    name: 'share_capital',
                    type: 'decimal',
                    label: 'Capital Social',
                    validations: {
                        required: false
                    },
                    columnSize: 12
                },
                values.client_type === 'J' && {
                    name: 'cnae',
                    type: 'text',
                    label: 'CNAE',
                    validations: {
                        required: false
                    },
                    columnSize: 12
                },
                {
                    name: 'address',
                    type: 'address',
                    label: 'Endereço',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'email',
                    type: 'email',
                    label: 'Email',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'phone_1',
                    type: 'phone',
                    label: 'Telefone 1',
                    validations: {
                        required: false
                    },
                    columnSize: 12
                },
                {
                    name: 'phone_2',
                    type: 'phone',
                    label: 'Telefone 2',
                    validations: {
                        required: false
                    },
                    columnSize: 12
                },
                {
                    name: 'login',
                    type: 'text',
                    label: 'Login',
                    validations: {
                        required: true,
                        login: true
                    },
                    columnSize: 12
                },
                {
                    name: 'password',
                    type: 'password',
                    label: 'Senha',
                    validations: {
                        password: true
                    },
                    columnSize: 12
                },
                {
                    name: 'password_confirm',
                    type: 'password',
                    label: 'Repetir senha',
                    validations: {
                        password_confirm: true
                    },
                    columnSize: 12
                },
                {
                    name: 'photo',
                    type: 'file',
                    label: 'Foto',
                    uploadPath: '/clients/',
                    extensionAccept: '.jpeg,.jpg,.png,.pdf',
                    limitFileSize: 2,
                    validations: {
                        required: false
                    },
                    columnSize: 12
                },
                {
                    name: 'status',
                    type: 'select',
                    options: [
                        { label: 'Ativo', value: '1' },
                        { label: 'Inativo', value: '0' }
                    ],
                    label: 'Status',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
            ],
            customValidators: {
                cnpj_unique: async (value, options, key, attributes) => {
                    const checkCnpj = async (value) => {
                        const pdc_entity_id = attributes.pdc_entity_id || profileFilter.pdc_entity_id

                        if (value.length >= 18 && pdc_entity_id) {
                            const cnpjExists = await Fetch.post(paths.endpointCnpjVerify, {
                                where: {
                                    pdc_entity_id,
                                    cnpj: value
                                }
                            })

                            if (cnpjExists.length > 0) {
                                if (id && cnpjExists[0].id == id) {
                                    return '';
                                } else {
                                    if (cnpjExists[0].deleted == 1) {
                                        return '^Existem registros de clientes deletados com esse CNPJ, crie um chamado para administração se necessário.';
                                    } else {
                                        return '^Já existe um cliente cadastrado com esse CNPJ.';
                                    }
                                }
                            }
                        }

                        return "";
                    }
                    return checkCnpj(value)
                },
                password: (value, options, key, attributes) => {
                    if (value.length < 8 && value.length > 0) {
                        return '^A senha deve ter no minímo 8 caracteres';
                    } else {
                        return '';
                    }
                },
                password_confirm: (value, options, key, attributes) => {
                    if (value !== attributes.password_confirm) {
                        return '^O campo repetir senha deve ter igual ao campo senha';
                    } else {
                        return '';
                    }
                },
                login: async (value, options, key, attributes) => {
                    const checkLogin = async (value) => {
                        const post = {
                            login: value
                        };

                        if (id) {
                            const post_client = {
                                id
                            };

                            const client = await Fetch.post(config.endpoints.backend + 'clients/getById', post_client);
                            post.user_id = client.core_user_id;
                        }

                        if (value.trim().length > 2) {
                            let response = await Fetch.post(config.endpoints.backend + 'core/users/getbylogin', post);
                            if (response.id) {
                                return '^O login já está sendo utilizado por outro usuário';
                            }
                        }

                        return "";
                    }
                    return checkLogin(value);
                }
            },
            ...paths,
            ...labels
        }
        form.values = values;
        return form;
    }

    useEffect(() => {
        const load = async () => {
            let values = {client_type: 'J'};
            if (id) {
                values = await Fetch.post(paths.endpointGetById, { id: id })
            }
            const form = getForm(values);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />}
                />
            )
        }
        load();
    }, [])

    return (
        <div>
            {formContent}
        </div>
    );
}
export default Form;
